export type SupportedLanguage = 'en' | 'fi' | 'sv';

export const getStoredLanguage = (supportedLanguages?: string[]): SupportedLanguage | null => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const storedLang = localStorage.getItem('language');
      if (storedLang) {
        // If supportedLanguages is provided, validate against it
        if (supportedLanguages) {
          return supportedLanguages.includes(storedLang) ? (storedLang as SupportedLanguage) : null;
        }
        // Otherwise, return the stored language (for backward compatibility)
        return storedLang as SupportedLanguage;
      }
    }
    return null;
  } catch (error) {
    console.warn('Unable to retrieve language preference:', error);
    return null;
  }
};

export const storeLanguage = (language: SupportedLanguage): void => {
  try {
    // Check if localStorage is available
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('language', language);
    }
  } catch (error) {
    // Silently fail if localStorage is not available
    console.warn('Unable to store language preference:', error);
  }
};

const normalizeLanguageTag = (languageTag: string): string => {
  return languageTag.toLowerCase().split(/[-_]/)[0] ?? '';
};

export const getBrowserLanguage = (supportedLanguages?: string[]): SupportedLanguage | null => {
  try {
    if (typeof navigator === 'undefined') return null;

    const candidateLanguages = [...(navigator.languages ?? []), navigator.language].filter(
      Boolean
    ) as string[];

    console.log(candidateLanguages);

    const supported = supportedLanguages ?? ['en', 'fi', 'sv'];

    for (const candidate of candidateLanguages) {
      if (supported.includes(candidate)) return candidate as SupportedLanguage;
      const normalized = normalizeLanguageTag(candidate);
      if (supported.includes(normalized)) return normalized as SupportedLanguage;
    }

    return null;
  } catch (error) {
    console.warn('Unable to read browser language:', error);
    return null;
  }
};
